import { StreamClient } from 'getstream';
import { createContext } from 'react';

export interface StreamChatContextState {
  /**
   * The StreamChat client instance.
   * It will be `null` until the client is initialized.
   */
  streamChatClient: StreamClient | null;

  /**
   * Indicates if the StreamChat client is currently loading.
   */
  loading: boolean;
}

export const StreamChatContext = createContext<StreamChatContextState | null>(null);
